import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93xu44z2gGgNMeta } from "/usr/src/app/pages/[...all].vue?macro=true";
import { default as about_45usCsa1Q1uHpWMeta } from "/usr/src/app/pages/about-us.vue?macro=true";
import { default as index6LTnG94DlyMeta } from "/usr/src/app/pages/account/index.vue?macro=true";
import { default as change_45mobile_45phone0QKNWy60RvMeta } from "/usr/src/app/pages/account/my-account/change-mobile-phone.vue?macro=true";
import { default as change_45passwordqp2Z11HRwOMeta } from "/usr/src/app/pages/account/my-account/change-password.vue?macro=true";
import { default as indexupeQyAlkI2Meta } from "/usr/src/app/pages/account/my-account/index.vue?macro=true";
import { default as _91id_935wMAzrPBCSMeta } from "/usr/src/app/pages/account/my-address/billing-address/[id].vue?macro=true";
import { default as newXMCPQbaDUXMeta } from "/usr/src/app/pages/account/my-address/billing-address/new.vue?macro=true";
import { default as index2q9jlx1r2mMeta } from "/usr/src/app/pages/account/my-address/index.vue?macro=true";
import { default as _91id_93kGUXo58ZHjMeta } from "/usr/src/app/pages/account/my-address/shipping-address/[id].vue?macro=true";
import { default as new8tnxWuyX5kMeta } from "/usr/src/app/pages/account/my-address/shipping-address/new.vue?macro=true";
import { default as indexPreSrIZscXMeta } from "/usr/src/app/pages/account/my-gallery/index.vue?macro=true";
import { default as _91id_93FiZjjl2prBMeta } from "/usr/src/app/pages/account/my-orders/[id].vue?macro=true";
import { default as indexJWPp3MhdXJMeta } from "/usr/src/app/pages/account/my-orders/index.vue?macro=true";
import { default as indexIDJ2HE4TsMMeta } from "/usr/src/app/pages/account/wishlist/index.vue?macro=true";
import { default as all_45stickerskv5bkbqN4gMeta } from "/usr/src/app/pages/all-stickers.vue?macro=true";
import { default as all_45stylesFSeexBw9yOMeta } from "/usr/src/app/pages/all-styles.vue?macro=true";
import { default as _91_91orderId_93_93lou9N0aGi3Meta } from "/usr/src/app/pages/backup_v1/checkout/[[orderId]].vue?macro=true";
import { default as _91_91collab_93_93Dof11oFhCjMeta } from "/usr/src/app/pages/backup_v1/collabs/[[collab]].vue?macro=true";
import { default as _91_91device_93_93da100QjX9vMeta } from "/usr/src/app/pages/backup_v1/devices/[[device]].vue?macro=true";
import { default as _91id_93sPN8GVSgt0Meta } from "/usr/src/app/pages/backup_v1/my-orders/[id].vue?macro=true";
import { default as indexz3d3efTHHnMeta } from "/usr/src/app/pages/backup_v1/my-orders/index.vue?macro=true";
import { default as indexQo3dF3iAviMeta } from "/usr/src/app/pages/backup_v1/personalization-cases/index.vue?macro=true";
import { default as print_45previewvXTCpLtfISMeta } from "/usr/src/app/pages/backup_v1/personalization-cases/print-preview.vue?macro=true";
import { default as index1NbfdkI1H3Meta } from "/usr/src/app/pages/backup_v1/personalization/index.vue?macro=true";
import { default as _91_91artworkSlug_93_93UIM6wyTazMMeta } from "/usr/src/app/pages/backup_v1/product/[deviceSlug]/[productSlug]/[[artworkSlug]].vue?macro=true";
import { default as indexLgj97GelE2Meta } from "/usr/src/app/pages/backup_v1/product/index.vue?macro=true";
import { default as _91_91product_93_93QozP5zG2LiMeta } from "/usr/src/app/pages/backup_v1/products/[[product]].vue?macro=true";
import { default as _91_91style_93_93axx2xXWpTjMeta } from "/usr/src/app/pages/backup_v1/styles/[[style]].vue?macro=true";
import { default as indexBEpo7p7UlsMeta } from "/usr/src/app/pages/blog/[blogSlug]/index.vue?macro=true";
import { default as indexgewR7USAlvMeta } from "/usr/src/app/pages/blog/index.vue?macro=true";
import { default as indexsaS3raqJOXMeta } from "/usr/src/app/pages/blogs/index.vue?macro=true";
import { default as _91_91orderId_93_93FV4GeIyDCZMeta } from "/usr/src/app/pages/checkout/[[orderId]].vue?macro=true";
import { default as _91_91category_93_93HtXVzf8gCPMeta } from "/usr/src/app/pages/collabs/[[category]].vue?macro=true";
import { default as _91_91category_93_93TDHV0D16PEMeta } from "/usr/src/app/pages/devices/[[category]].vue?macro=true";
import { default as indexr50dbNePf7Meta } from "/usr/src/app/pages/faqs/[page]/index.vue?macro=true";
import { default as indexjH3R0qzS44Meta } from "/usr/src/app/pages/faqs/index.vue?macro=true";
import { default as forgot_45passwordP0Nxfp4jaIMeta } from "/usr/src/app/pages/forgot-password.vue?macro=true";
import { default as _91orderId_93JKk7jH2P0HMeta } from "/usr/src/app/pages/order-confirmation/[orderId].vue?macro=true";
import { default as personal_45data_45consentqzGsnfX6cSMeta } from "/usr/src/app/pages/personal-data-consent.vue?macro=true";
import { default as indexzKdhFJIROCMeta } from "/usr/src/app/pages/personalization-cases/index.vue?macro=true";
import { default as print_45previewnZNCKfqDIpMeta } from "/usr/src/app/pages/personalization-cases/print-preview.vue?macro=true";
import { default as indexZ27uwGosD4Meta } from "/usr/src/app/pages/personalization/index.vue?macro=true";
import { default as privacy_45policy1IN0o4tDn5Meta } from "/usr/src/app/pages/privacy-policy.vue?macro=true";
import { default as index7bajDfgDlgMeta } from "/usr/src/app/pages/product/[...slug]/index.vue?macro=true";
import { default as _91_91category_93_939qT7kC3zecMeta } from "/usr/src/app/pages/products/[[category]].vue?macro=true";
import { default as promotionsVv1pwQg7gdMeta } from "/usr/src/app/pages/promotions.vue?macro=true";
import { default as sign_45in7sEcJLcQCLMeta } from "/usr/src/app/pages/sign-in.vue?macro=true";
import { default as sign_45upmDla61cpoeMeta } from "/usr/src/app/pages/sign-up.vue?macro=true";
import { default as _91_91category_93_93CJf2UkHemRMeta } from "/usr/src/app/pages/styles/[[category]].vue?macro=true";
import { default as terms_45and_45conditionsHpOQ6YMMEAMeta } from "/usr/src/app/pages/terms-and-conditions.vue?macro=true";
import { default as visit_45usUDa8t04gq7Meta } from "/usr/src/app/pages/visit-us.vue?macro=true";
import { default as component_45stubuYxk0V0rW5Meta } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubuYxk0V0rW5 } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "all___en",
    path: "/en/:all(.*)*",
    component: () => import("/usr/src/app/pages/[...all].vue").then(m => m.default || m)
  },
  {
    name: "all___th",
    path: "/th/:all(.*)*",
    component: () => import("/usr/src/app/pages/[...all].vue").then(m => m.default || m)
  },
  {
    name: "about-us___en",
    path: "/en/about-us",
    component: () => import("/usr/src/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___th",
    path: "/th/about-us",
    component: () => import("/usr/src/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: index6LTnG94DlyMeta || {},
    component: () => import("/usr/src/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___th",
    path: "/th/account",
    meta: index6LTnG94DlyMeta || {},
    component: () => import("/usr/src/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-account-change-mobile-phone___en",
    path: "/en/account/my-account/change-mobile-phone",
    component: () => import("/usr/src/app/pages/account/my-account/change-mobile-phone.vue").then(m => m.default || m)
  },
  {
    name: "account-my-account-change-mobile-phone___th",
    path: "/th/account/my-account/change-mobile-phone",
    component: () => import("/usr/src/app/pages/account/my-account/change-mobile-phone.vue").then(m => m.default || m)
  },
  {
    name: "account-my-account-change-password___en",
    path: "/en/account/my-account/change-password",
    component: () => import("/usr/src/app/pages/account/my-account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-my-account-change-password___th",
    path: "/th/account/my-account/change-password",
    component: () => import("/usr/src/app/pages/account/my-account/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-my-account___en",
    path: "/en/account/my-account",
    component: () => import("/usr/src/app/pages/account/my-account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-account___th",
    path: "/th/account/my-account",
    component: () => import("/usr/src/app/pages/account/my-account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-billing-address-id___en",
    path: "/en/account/my-address/billing-address/:id()",
    component: () => import("/usr/src/app/pages/account/my-address/billing-address/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-billing-address-id___th",
    path: "/th/account/my-address/billing-address/:id()",
    component: () => import("/usr/src/app/pages/account/my-address/billing-address/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-billing-address-new___en",
    path: "/en/account/my-address/billing-address/new",
    component: () => import("/usr/src/app/pages/account/my-address/billing-address/new.vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-billing-address-new___th",
    path: "/th/account/my-address/billing-address/new",
    component: () => import("/usr/src/app/pages/account/my-address/billing-address/new.vue").then(m => m.default || m)
  },
  {
    name: "account-my-address___en",
    path: "/en/account/my-address",
    component: () => import("/usr/src/app/pages/account/my-address/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-address___th",
    path: "/th/account/my-address",
    component: () => import("/usr/src/app/pages/account/my-address/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-shipping-address-id___en",
    path: "/en/account/my-address/shipping-address/:id()",
    component: () => import("/usr/src/app/pages/account/my-address/shipping-address/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-shipping-address-id___th",
    path: "/th/account/my-address/shipping-address/:id()",
    component: () => import("/usr/src/app/pages/account/my-address/shipping-address/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-shipping-address-new___en",
    path: "/en/account/my-address/shipping-address/new",
    component: () => import("/usr/src/app/pages/account/my-address/shipping-address/new.vue").then(m => m.default || m)
  },
  {
    name: "account-my-address-shipping-address-new___th",
    path: "/th/account/my-address/shipping-address/new",
    component: () => import("/usr/src/app/pages/account/my-address/shipping-address/new.vue").then(m => m.default || m)
  },
  {
    name: "account-my-gallery___en",
    path: "/en/account/my-gallery",
    component: () => import("/usr/src/app/pages/account/my-gallery/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-gallery___th",
    path: "/th/account/my-gallery",
    component: () => import("/usr/src/app/pages/account/my-gallery/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-orders-id___en",
    path: "/en/account/my-orders/:id()",
    component: () => import("/usr/src/app/pages/account/my-orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-my-orders-id___th",
    path: "/th/account/my-orders/:id()",
    component: () => import("/usr/src/app/pages/account/my-orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-my-orders___en",
    path: "/en/account/my-orders",
    component: () => import("/usr/src/app/pages/account/my-orders/index.vue").then(m => m.default || m)
  },
  {
    name: "account-my-orders___th",
    path: "/th/account/my-orders",
    component: () => import("/usr/src/app/pages/account/my-orders/index.vue").then(m => m.default || m)
  },
  {
    name: "account-wishlist___en",
    path: "/en/account/wishlist",
    component: () => import("/usr/src/app/pages/account/wishlist/index.vue").then(m => m.default || m)
  },
  {
    name: "account-wishlist___th",
    path: "/th/account/wishlist",
    component: () => import("/usr/src/app/pages/account/wishlist/index.vue").then(m => m.default || m)
  },
  {
    name: "all-stickers___en",
    path: "/en/all-stickers",
    component: () => import("/usr/src/app/pages/all-stickers.vue").then(m => m.default || m)
  },
  {
    name: "all-stickers___th",
    path: "/th/all-stickers",
    component: () => import("/usr/src/app/pages/all-stickers.vue").then(m => m.default || m)
  },
  {
    name: "all-styles___en",
    path: "/en/all-styles",
    component: () => import("/usr/src/app/pages/all-styles.vue").then(m => m.default || m)
  },
  {
    name: "all-styles___th",
    path: "/th/all-styles",
    component: () => import("/usr/src/app/pages/all-styles.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-checkout-orderId___en",
    path: "/en/backup_v1/checkout/:orderId?",
    meta: _91_91orderId_93_93lou9N0aGi3Meta || {},
    component: () => import("/usr/src/app/pages/backup_v1/checkout/[[orderId]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-checkout-orderId___th",
    path: "/th/backup_v1/checkout/:orderId?",
    meta: _91_91orderId_93_93lou9N0aGi3Meta || {},
    component: () => import("/usr/src/app/pages/backup_v1/checkout/[[orderId]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-collabs-collab___en",
    path: "/en/backup_v1/collabs/:collab?",
    component: () => import("/usr/src/app/pages/backup_v1/collabs/[[collab]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-collabs-collab___th",
    path: "/th/backup_v1/collabs/:collab?",
    component: () => import("/usr/src/app/pages/backup_v1/collabs/[[collab]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-devices-device___en",
    path: "/en/backup_v1/devices/:device?",
    component: () => import("/usr/src/app/pages/backup_v1/devices/[[device]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-devices-device___th",
    path: "/th/backup_v1/devices/:device?",
    component: () => import("/usr/src/app/pages/backup_v1/devices/[[device]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-my-orders-id___en",
    path: "/en/backup_v1/my-orders/:id()",
    component: () => import("/usr/src/app/pages/backup_v1/my-orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-my-orders-id___th",
    path: "/th/backup_v1/my-orders/:id()",
    component: () => import("/usr/src/app/pages/backup_v1/my-orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-my-orders___en",
    path: "/en/backup_v1/my-orders",
    component: () => import("/usr/src/app/pages/backup_v1/my-orders/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-my-orders___th",
    path: "/th/backup_v1/my-orders",
    component: () => import("/usr/src/app/pages/backup_v1/my-orders/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-personalization-cases___en",
    path: "/en/backup_v1/personalization-cases",
    meta: indexQo3dF3iAviMeta || {},
    component: () => import("/usr/src/app/pages/backup_v1/personalization-cases/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-personalization-cases___th",
    path: "/th/backup_v1/personalization-cases",
    meta: indexQo3dF3iAviMeta || {},
    component: () => import("/usr/src/app/pages/backup_v1/personalization-cases/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-personalization-cases-print-preview___en",
    path: "/en/backup_v1/personalization-cases/print-preview",
    meta: print_45previewvXTCpLtfISMeta || {},
    component: () => import("/usr/src/app/pages/backup_v1/personalization-cases/print-preview.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-personalization-cases-print-preview___th",
    path: "/th/backup_v1/personalization-cases/print-preview",
    meta: print_45previewvXTCpLtfISMeta || {},
    component: () => import("/usr/src/app/pages/backup_v1/personalization-cases/print-preview.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-personalization___en",
    path: "/en/backup_v1/personalization",
    component: () => import("/usr/src/app/pages/backup_v1/personalization/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-personalization___th",
    path: "/th/backup_v1/personalization",
    component: () => import("/usr/src/app/pages/backup_v1/personalization/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-product-deviceSlug-productSlug-artworkSlug___en",
    path: "/en/backup_v1/product/:deviceSlug()/:productSlug()/:artworkSlug?",
    meta: _91_91artworkSlug_93_93UIM6wyTazMMeta || {},
    component: () => import("/usr/src/app/pages/backup_v1/product/[deviceSlug]/[productSlug]/[[artworkSlug]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-product-deviceSlug-productSlug-artworkSlug___th",
    path: "/th/backup_v1/product/:deviceSlug()/:productSlug()/:artworkSlug?",
    meta: _91_91artworkSlug_93_93UIM6wyTazMMeta || {},
    component: () => import("/usr/src/app/pages/backup_v1/product/[deviceSlug]/[productSlug]/[[artworkSlug]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-product___en",
    path: "/en/backup_v1/product",
    component: () => import("/usr/src/app/pages/backup_v1/product/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-product___th",
    path: "/th/backup_v1/product",
    component: () => import("/usr/src/app/pages/backup_v1/product/index.vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-products-product___en",
    path: "/en/backup_v1/products/:product?",
    component: () => import("/usr/src/app/pages/backup_v1/products/[[product]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-products-product___th",
    path: "/th/backup_v1/products/:product?",
    component: () => import("/usr/src/app/pages/backup_v1/products/[[product]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-styles-style___en",
    path: "/en/backup_v1/styles/:style?",
    component: () => import("/usr/src/app/pages/backup_v1/styles/[[style]].vue").then(m => m.default || m)
  },
  {
    name: "backup_v1-styles-style___th",
    path: "/th/backup_v1/styles/:style?",
    component: () => import("/usr/src/app/pages/backup_v1/styles/[[style]].vue").then(m => m.default || m)
  },
  {
    name: "blog-blogSlug___en",
    path: "/en/blog/:blogSlug()",
    component: () => import("/usr/src/app/pages/blog/[blogSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-blogSlug___th",
    path: "/th/blog/:blogSlug()",
    component: () => import("/usr/src/app/pages/blog/[blogSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/usr/src/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog___th",
    path: "/th/blog",
    component: () => import("/usr/src/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blogs___en",
    path: "/en/blogs",
    component: () => import("/usr/src/app/pages/blogs/index.vue").then(m => m.default || m)
  },
  {
    name: "blogs___th",
    path: "/th/blogs",
    component: () => import("/usr/src/app/pages/blogs/index.vue").then(m => m.default || m)
  },
  {
    name: "checkout-orderId___en",
    path: "/en/checkout/:orderId?",
    meta: _91_91orderId_93_93FV4GeIyDCZMeta || {},
    component: () => import("/usr/src/app/pages/checkout/[[orderId]].vue").then(m => m.default || m)
  },
  {
    name: "checkout-orderId___th",
    path: "/th/checkout/:orderId?",
    meta: _91_91orderId_93_93FV4GeIyDCZMeta || {},
    component: () => import("/usr/src/app/pages/checkout/[[orderId]].vue").then(m => m.default || m)
  },
  {
    name: "collabs-category___en",
    path: "/en/collabs/:category?",
    meta: _91_91category_93_93HtXVzf8gCPMeta || {},
    component: () => import("/usr/src/app/pages/collabs/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "collabs-category___th",
    path: "/th/collabs/:category?",
    meta: _91_91category_93_93HtXVzf8gCPMeta || {},
    component: () => import("/usr/src/app/pages/collabs/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "devices-category___en",
    path: "/en/devices/:category?",
    meta: _91_91category_93_93TDHV0D16PEMeta || {},
    component: () => import("/usr/src/app/pages/devices/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "devices-category___th",
    path: "/th/devices/:category?",
    meta: _91_91category_93_93TDHV0D16PEMeta || {},
    component: () => import("/usr/src/app/pages/devices/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "faqs-page___en",
    path: "/en/faqs/:page()",
    component: () => import("/usr/src/app/pages/faqs/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: "faqs-page___th",
    path: "/th/faqs/:page()",
    component: () => import("/usr/src/app/pages/faqs/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    component: () => import("/usr/src/app/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: "faqs___th",
    path: "/th/faqs",
    component: () => import("/usr/src/app/pages/faqs/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordP0Nxfp4jaIMeta || {},
    component: () => import("/usr/src/app/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: "forgot-password___th",
    path: "/th/forgot-password",
    meta: forgot_45passwordP0Nxfp4jaIMeta || {},
    component: () => import("/usr/src/app/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "order-confirmation-orderId___en",
    path: "/en/order-confirmation/:orderId()",
    meta: _91orderId_93JKk7jH2P0HMeta || {},
    component: () => import("/usr/src/app/pages/order-confirmation/[orderId].vue").then(m => m.default || m)
  },
  {
    name: "order-confirmation-orderId___th",
    path: "/th/order-confirmation/:orderId()",
    meta: _91orderId_93JKk7jH2P0HMeta || {},
    component: () => import("/usr/src/app/pages/order-confirmation/[orderId].vue").then(m => m.default || m)
  },
  {
    name: "personal-data-consent___en",
    path: "/en/personal-data-consent",
    component: () => import("/usr/src/app/pages/personal-data-consent.vue").then(m => m.default || m)
  },
  {
    name: "personal-data-consent___th",
    path: "/th/personal-data-consent",
    component: () => import("/usr/src/app/pages/personal-data-consent.vue").then(m => m.default || m)
  },
  {
    name: "personalization-cases___en",
    path: "/en/personalization-cases",
    meta: indexzKdhFJIROCMeta || {},
    component: () => import("/usr/src/app/pages/personalization-cases/index.vue").then(m => m.default || m)
  },
  {
    name: "personalization-cases___th",
    path: "/th/personalization-cases",
    meta: indexzKdhFJIROCMeta || {},
    component: () => import("/usr/src/app/pages/personalization-cases/index.vue").then(m => m.default || m)
  },
  {
    name: "personalization-cases-print-preview___en",
    path: "/en/personalization-cases/print-preview",
    meta: print_45previewnZNCKfqDIpMeta || {},
    component: () => import("/usr/src/app/pages/personalization-cases/print-preview.vue").then(m => m.default || m)
  },
  {
    name: "personalization-cases-print-preview___th",
    path: "/th/personalization-cases/print-preview",
    meta: print_45previewnZNCKfqDIpMeta || {},
    component: () => import("/usr/src/app/pages/personalization-cases/print-preview.vue").then(m => m.default || m)
  },
  {
    name: "personalization___en",
    path: "/en/personalization",
    meta: indexZ27uwGosD4Meta || {},
    component: () => import("/usr/src/app/pages/personalization/index.vue").then(m => m.default || m)
  },
  {
    name: "personalization___th",
    path: "/th/personalization",
    meta: indexZ27uwGosD4Meta || {},
    component: () => import("/usr/src/app/pages/personalization/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/usr/src/app/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___th",
    path: "/th/privacy-policy",
    component: () => import("/usr/src/app/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "product-slug___en",
    path: "/en/product/:slug(.*)*",
    meta: index7bajDfgDlgMeta || {},
    component: () => import("/usr/src/app/pages/product/[...slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "product-slug___th",
    path: "/th/product/:slug(.*)*",
    meta: index7bajDfgDlgMeta || {},
    component: () => import("/usr/src/app/pages/product/[...slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "products-category___en",
    path: "/en/products/:category?",
    meta: _91_91category_93_939qT7kC3zecMeta || {},
    component: () => import("/usr/src/app/pages/products/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "products-category___th",
    path: "/th/products/:category?",
    meta: _91_91category_93_939qT7kC3zecMeta || {},
    component: () => import("/usr/src/app/pages/products/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "promotions___en",
    path: "/en/promotions",
    component: () => import("/usr/src/app/pages/promotions.vue").then(m => m.default || m)
  },
  {
    name: "promotions___th",
    path: "/th/promotions",
    component: () => import("/usr/src/app/pages/promotions.vue").then(m => m.default || m)
  },
  {
    name: "sign-in___en",
    path: "/en/sign-in",
    meta: sign_45in7sEcJLcQCLMeta || {},
    component: () => import("/usr/src/app/pages/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "sign-in___th",
    path: "/th/sign-in",
    meta: sign_45in7sEcJLcQCLMeta || {},
    component: () => import("/usr/src/app/pages/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    meta: sign_45upmDla61cpoeMeta || {},
    component: () => import("/usr/src/app/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___th",
    path: "/th/sign-up",
    meta: sign_45upmDla61cpoeMeta || {},
    component: () => import("/usr/src/app/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: "styles-category___en",
    path: "/en/styles/:category?",
    meta: _91_91category_93_93CJf2UkHemRMeta || {},
    component: () => import("/usr/src/app/pages/styles/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "styles-category___th",
    path: "/th/styles/:category?",
    meta: _91_91category_93_93CJf2UkHemRMeta || {},
    component: () => import("/usr/src/app/pages/styles/[[category]].vue").then(m => m.default || m)
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("/usr/src/app/pages/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: "terms-and-conditions___th",
    path: "/th/terms-and-conditions",
    component: () => import("/usr/src/app/pages/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: "visit-us___en",
    path: "/en/visit-us",
    component: () => import("/usr/src/app/pages/visit-us.vue").then(m => m.default || m)
  },
  {
    name: "visit-us___th",
    path: "/th/visit-us",
    component: () => import("/usr/src/app/pages/visit-us.vue").then(m => m.default || m)
  },
  {
    name: component_45stubuYxk0V0rW5Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubuYxk0V0rW5
  }
]